module.exports = {"pageTitleText":"緩存清除","addBtnText":"清除快取"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/cacheclear.json
// module id = +wot
// module chunks = 3